export const isQuickPicksV2PayoutType = (payoutMultiplierType?: string): boolean =>
  payoutMultiplierType === 'peer_to_peer_v2';
